
const Preloader =()=>{
  return(
      <div className="mt-5" style={{position:"absolute",top:"30%",left:"48%"}}>
          <div class="spinner-border text-custom"></div>
      </div>
  )
}
export default Preloader;